<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
-->

<template>
  <div class="app-tos-container">
    <p class="font-bold">
      By clicking 'Sign Me Up!' below, you are agreeing to the
      ExclusionCheck.com
      <a @click.stop="termsDialog = true">Terms and Conditions</a>, which
      includes these main points:
    </p>
    <p class="app-terms-summary">
      Permitted uses of ExclusionCheck are to combat fraud and abuse in
      healthcare by searching and/or monitoring employees and vendors against
      federal and state exclusion lists.
    </p>
    <p class="app-terms-summary">
      Identifiers include Name, SSN &amp; NPI for searching.
    </p>
    <p class="app-terms-summary">
      ExclusionCheck does not process or require any PHI
    </p>

    <v-dialog v-model="termsDialog" max-width="60rem">
      <v-card>
        <v-card-text>
          <p>EXCLUSIONCHECK.COM TERMS OF SERVICE</p>
          <p>
            IMPORTANT: READ CAREFULLY: BY CREATING AN ACCOUNT OR BY UTILIZING
            EXCLUSIONCHECK.COM SERVICE, CLIENT AGREES TO BE BOUND BY THESE
            TERMS, DISCLAIMERS AND CONDITIONS.
          </p>
          <p>
            Welcome to Exclusioncheck.com! ExclusionCheck.com is an online
            exclusion data search service that aggregates primary source state
            and federal exclusion records. Your use of the Services is subject
            to these Terms of Service and Exclusioncheck.com’s Privacy Policy
            (collectively referred to as the “Services”). These Terms of Service
            are a legal agreement between you and Exclusioncheck.com, a service
            of ProviderTrust, Inc, (herinafter, collectively referred to as the
            “Company”), a Tennessee corporation, for the authorized use of the
            Services. “You” refers to any individual or company that creates an
            account on the Services, or if the Services are being used on behalf
            of an entity, by an authorized individual of such company. If you
            are accessing the Services on behalf of your employer, then you
            represent and warrant that you have the authority to agree to these
            Terms of Service on its behalf. IF you do NOT agree to these Terms
            of Services, then do NOT use the Services.
          </p>
          <p class="app-tos-topic">Description of Services:</p>
          <p>
            Exclusioncheck.com will allow you to conduct a point in time search
            of a name, NPI or SSN via a single search or batch file against
            certain Exclusioncheck.com available lists. You can search by name,
            NPI or a batch search. However, the responsibility to conduct
            further investigation to determine if such possible name or NPI
            exclusion record belongs to your employee/third party. The mere
            existence of a possible name only exclusion record, does not
            necessarily indicate a confirmed match.
          </p>
          <p>
            Accessing Exclusioncheck.com is allowed upon electronically signing
            and agreeing to the following terms and conditions:
          </p>
          <p class="app-tos-topic">Registration:</p>
          <p>
            In order to use the Services, You must have a Valid Account. Your
            use of the product is subject to a license agreement, more fully
            described below. All information in Exclusioncheck.com is licensed
            and has restrictions on its use. The data and content may not be
            used or disclosed in violation of the terms and conditions of the
            License Agreement. You must be authorized, and have valid
            credentials (user identification and password), to enter
            Exclusioncheck.com. Client agrees: (i) to assign users to access
            Exclusioncheck.com, and (ii) to promptly notify Exclusioncheck.com
            when Client suspects or determines that any personnel account ID or
            password has been lost, stolen, or otherwise compromised, and (iii)
            to pay for Services rendered by Exclusioncheck.com in good faith
            reliance on such personnel account ID and password prior to
            Exclusioncheck.com’s receipt of such notice.
          </p>

          <p class="app-tos-topic">Compliance with Laws and Regulations:</p>
          <p>
            Your use of ExclusionCheck.com and the content contained therein
            must be in compliance with all applicable federal and state laws,
            rules and regulation. No decision to terminate an individual or
            contract with a third party should be made unless and until you
            separately take action to determine if the potential exclusion
            record that is returned and published for your review on
            Exclusioncheck.com belongs to the individual or entity that you have
            searched.
          </p>
          <p>
            As the employer/contractor responsible for entering sufficient
            identifiers necessary to search a person or third party in
            Exclusioncheck.com., you agree, by utilizing these services, that
            your company will conduct the final and necessary task of confirming
            that the potential exclusion record belongs to your employee/third
            party. In order to accomplish this task, Exclusioncheck.com will
            provide a direct link to the primary source whereby you can enter
            other identifiers on such primary source site in order to confirm
            whether the name match belongs to your employee/third party. Most
            primary source sites require additional identifiers in order to
            determine if the possible name match belongs to your individual. In
            the event that said primary source sites do not contain any further
            identifiers, the decision of whether the possible name match record
            belongs to your employee or third party rests with you and your
            company.
          </p>
          <p>
            Exclusioncheck.com, by and through ProviderTrust, Inc., does not and
            cannot make an employment of contract decision on your behalf, nor
            does it assume liability for any decision that you make with regard
            to an exclusion record, except as provided below. Further, you agree
            to defend, indemnify and hold Exclusioncheck.com and/or
            ProviderTrust,Inc. harmless from and against all claims and losses
            arising from or relating to misuse or unlawful use of the system
            and/or the content contained therein. Further, you agree to abide by
            any state or federal employment laws, including but not limited to
            the Fair Credit Reporting Act, as amended.
          </p>
          <p class="app-tos-topic">Warranty Disclaimer:</p>
          <p>
            Neither Exclusioncheck.com nor ProviderTrust.Inc., warrants the
            accuracy, completeness or timeliness of the information contained in
            ExclusionCheck.com, except that the data contained herein was
            obtained from public records and is updated at least on a monthly
            basis. Further, no independent verification of the accuracy or
            completeness of the primary source information has been performed by
            Exclusioncheck.com and/or ProviderTrust, Inc.
          </p>
          <p>
            Before relying on the information, the user should obtain
            confirmation of its accuracy from the originating agency. Neither
            ExclusionCheck.com nor ProviderTrust.Inc., has undertaken to correct
            any reported information, including information that might be
            incorrect on its face.
          </p>
          <p>
            The data contained in the system is updated periodically; however,
            there is a lag time between when an agency takes an action and when
            they report it and there may be a lag time between when the record
            is released as public record and when it is updated into
            ExclusionCheck.com. Exclusioncheck.com strives to update its
            database within 24 hours of downloading such new data in to
            Exclusioncheck.com. ExclusionCheck.com is not a government agency or
            database. ExclusionCheck.com does not warrant or represent that the
            data that is included represents all publicly available exclusions.
            All attempts have been made to gather the most current data sets
            from the primary sources.
          </p>
          <p>
            As an authorized user, you can search Exclusioncheck.com by entering
            (i) the first and last name of an individual, (ii) the name of an
            entity, (iii) the Social Security Number of an individual , or (iv)
            the NPI for an individual or entity. If an exclusion record contains
            a possible name match and/or NPI number match, Exclusioncheck.com
            will provide any and all possible name matches or NPI matches.
          </p>
          <p>
            <span class="app-tos-sub-topic">No PHI:</span> Exclusioncheck.com
            will not accept from Client, process, maintain or store any Personal
            Health Information (as defined in the Health Information Portability
            and Accountability Act of 1996, as amended) as a part of its
            Services.
          </p>
          <p>
            <span class="app-tos-sub-topic">Updates and Use of Site:</span>
            Client hereby acknowledges and agrees to the Terms of Service and
            Privacy Policy applicable to and set forth on this site (as updated
            or modified from time to time), as the same may be amended from time
            to time. Exclusioncheck.com and/or ProviderTrust may discontinue,
            change, or suspend any aspect of the website at any time. As such,
            Exclusioncheck.com and/or ProviderTrust may change, discontinue or
            suspend the availability of any database, content, feature, or
            product of the website.
          </p>
          <p>
            <span class="app-tos-sub-topic"
              >Exclusioncheck.com Responsibilities:</span
            >
            Exclusioncheck.com, by and through ProviderTrust, Inc., (hereinafter
            referred collectively as “Company”) represents and warrants that it
            will accurately report to Client all information that Company has
            received from the Primary Source(s). The Company Inputs and Outputs
            will be provided “AS IS.” The Company does not otherwise warrant or
            authenticate the reliability of the Company Inputs or Outputs and
            disclaims all other representations and warranties, express or
            implied, including but not limited to any warranties of
            merchantability, fitness for any particular purpose, accuracy,
            interoperability, non-infringement and title. Company will have no
            liability for relying on incorrect, inaccurate or incomplete Client
            Data or information provided to Company by a Primary Source, and for
            communicating such information in its entirety without alteration to
            Client.
          </p>
          <p>
            <span class="app-tos-sub-topic">No Resale/ No export :</span> Client
            expressly agrees that it will not reproduce, duplicate, sell,
            resell, exploit and/or does not have permission to aggregate,
            reverse engineer or decompile or export for commercial use any of
            the data found on Exclusioncheck.com.
          </p>

          <p class="app-tos-topic">
            Authorization to charge credit card & Billing and Payment Terms:
          </p>
          <p>
            <span class="app-tos-billing-sub-topic"
              >A monthly subscription based on your plan.</span
            >
            <span class="app-tos-billing-sub-topic">Single Team: $30</span>
            <span class="app-tos-billing-sub-topic">Multi-Team: $75</span>
          </p>
          <p>
            <span class="app-tos-billing-sub-topic"
              >In addition to the subscription we'll have per search rates
              at:</span
            >
            <span class="app-tos-billing-sub-topic"
              >Name Exclusion Searches: .15</span
            >
            <span class="app-tos-billing-sub-topic">OFAC: .05</span>
            <span class="app-tos-billing-sub-topic">SSNDMF: .05</span>
            <span class="app-tos-billing-sub-topic">NPI: .20</span>
          </p>
          <p>
            Additional groupings of features may be added to the Service and
            made available to You as a paid upgrade ("Paid Plan"). If You choose
            to subscribe to a Paid Plan, You shall pay fees (described below) to
            Company. Upon selection of a Paid Plan, You will provide Company
            with the necessary billing information ("Billing Data"). <br />
            Credit cards are the only payment mechanism Company will accept for
            payment of a monthly subscription fee ("Subscription Fee") for a
            Paid Plan. All currency references are in U.S. dollars. Paid Plans
            can be paid as a monthly Subscription Fee.
          </p>
          <p>
            If you select a Paid Plan, You must provide current, complete and
            accurate Billing Data. You must promptly update all Billing Data to
            keep Your Account current, complete and accurate (such as a change
            in billing address, credit card number or credit card expiration
            date) and You must promptly notify Company if Your Payment Method is
            changed (for example, for loss or theft) or if You become aware of a
            potential breach of security, such as the unauthorized disclosure or
            use of Your name or password. If You fail to provide any of the
            foregoing information, You agree that Company may continue charging
            You for any use of the Paid Plan under your Billing Data unless You
            have terminated Your Paid Plan as set forth herein. By selecting the
            Monthly Fee, the credit card that You provide as part of the Billing
            Data will be automatically and immediately billed on the first
            Business Day of each Month. You agree that Company may charge to
            Your credit card all amounts due and owing for Your Account on that
            monthly basis or upon cancellation.
          </p>
          <p>
            Company may change prices at any time without prior notice, but will
            endeavor to provide reasonable advance notice via the Company
            website and/or electronic mail. You agree that in the event Company
            is unable to collect the fees owed to Company for Your Account
            through Your Subscription Fee, Company may take any other steps it
            deems necessary to collect such fees from You and that You will be
            responsible for all costs and expenses incurred by Company in
            connection with such collection activity, including collection fees,
            court costs and attorneys' fees.
          </p>
          <p>
            As long as Your Account remains active and in good standing, You
            will be charged the Subscription Fee even if You never use the
            service. You may, however, cancel Your Paid Plan at any time.
          </p>
          <p class="app-tos-topic-bold">
            Term/Breach/Suspension: <br />
            Term: Month to month. Cancellation responsibility is solely on the
            User.
          </p>
          <p>
            If Your Subscription Fee payment is overdue, Company will disable
            Your access to the features provided by the Paid Plan. Company may,
            at its sole discretion, at any time and for any reason, terminate
            the Service, terminate this Agreement, or suspend or terminate Your
            Account. In the event of suspension or termination, Your account
            will be disabled and You may not be granted access to Your Account
            or any files or other Content (including Your User Content)
            contained in Your Account, and Company may delete Your User Content,
            although residual copies of information may remain in our system for
            some time for back-up purposes. In the event of termination, Company
            may also withdraw and at its discretion reallocate the public web
            address of Your Account.
          </p>
          <p>
            <span class="app-tos-sub-topic">Cancellation/Refund Policy.</span>
            You may cancel your ExclusionCheck account at any time. Access and
            service will continue until your next billing period at which time
            we’ll disable your account and charge you for the prior billing
            period’s monthly fee and any activity during that time. Sorry No
            Refunds will be offered.
          </p>
          <p>
            If You terminate Your Account, via means provided for cancellation
            on the Company website, or via telephone call or electronic mail to
            Company, and You request that Company delete Your User Content and
            files contained in Your Account, Company will make all reasonable
            efforts to do so.
          </p>
          <p>
            <span class="app-tos-sub-topic">Effect of Termination.</span> Upon
            any termination or expiration of this Agreement, (i) Client’s
            license to access and use the CompanyIP shall automatically
            terminate; and (ii) Client shall promptly pay any outstanding
            amounts due the Company. Further, WE RESERVE THE RIGHT TO ISSUE A
            WARNING OR TO SUSPEND OR EVEN TERMINATE YOUR SERVICE AND ACCESS TO
            OUR WEBSITE OR APP IF WE DETERMINE YOU HAVE VIOLATED ANY OF THE
            TERMS OF SERVICE LISTED ON THIS PAGE, ANY OF THE RULES OR POLICIES
            IMPLIED BY THE USE OF OUR SITE, OR FOR ANY OTHER REASON.
          </p>
          <p>
            <span class="app-tos-sub-topic"
              >Proprietary and Intellectual Property Rights:</span
            >
            Client acknowledges and agrees that the Services are provided on a
            subscription basis and not “sold” to Client. All right, title and
            interest in and to the Services, the Websites and related software,
            and any update, adaptation, translation, customization or derivative
            work of the same, including all intellectual property rights therein
            (collectively, the <b>“Company IP”</b>), are and will remain with
            Company (or its third party licensors, as applicable).
            ProviderTrust, by and through Exclusioncheck.com, hereby grants
            Client a limited, revocable, non-exclusive, non-transferable,
            non-sublicenseable, license to access and use the Company IP during
            the Term, provided that Client will not: (i) modify, reverse
            engineer, or create derivative works from the CompanyIP; (ii)
            publicly display, lend, sell, transfer or sublicense the Company IP
            or in any other way allow third parties to exploit the Company IP;
            (iii) use the Company IP for purposes other than for Client’s
            internal business operations; (iv) use the Company IP in violation
            of any federal, state or local law, rule or regulation; or (v)
            disclose the trade secrets embodied in the Company IP to any third
            party.
          </p>
          <p>
            <span class="app-tos-sub-topic">Taxes:</span> Client will be
            responsible for all sales, use and excise taxes, and any other
            similar taxes, duties and charges of any kind, including Internet
            taxes, imposed by any federal, state or local governmental entity on
            the Services provided or on any amounts payable by Client hereunder.
          </p>
          <p>
            <span class="app-tos-sub-topic">Injunctive Relief:</span> You
            acknowledge that any use of the Service contrary to this Agreement,
            or any transfer, sublicensing, copying or disclosure of technical
            information or materials related to the Service, may cause
            irreparable injury to Company, its affiliates, suppliers and any
            other party authorized by Company to resell, distribute, or promote
            the Service ("Resellers"), and under such circumstances Company, its
            affiliates, suppliers and Resellers will be entitled to equitable
            relief, without posting bond or other security, including, but not
            limited to, preliminary and permanent injunctive relief.
          </p>
          <p>
            <span class="app-tos-sub-topic">Use and Storage Practices:</span>
            You agree that Company has no responsibility or liability for the
            deletion of, or the failure to store or to transmit, any User
            Content and other communications maintained by the Service. You
            acknowledge that Company may establish general practices and limits
            concerning use of the Service and may modify such practices and
            limits from time to time. Company retains the right to create limits
            on use and storage at our sole discretion at any time with or
            without notice. You acknowledge that we reserve the right to log off
            users who are inactive for an extended period of time.
          </p>

          <p class="app-tos-topic">You agree that You will not:</p>
          <p>
            (a) upload, post, email, or otherwise transmit any computer
            routines, files or programs designed to interrupt, destroy or limit
            the functionality of any computer software or hardware or
            telecommunications equipment; <br />
            (b) interfere with or disrupt our Service or networks connected to
            our website or through the use of our Service, or disobey any
            requirements, procedures, policies or regulations of networks
            connected to our website or through the use of our Service, or
            otherwise interfere with our Service in any way, including through
            the use of JavaScript, ActiveX or other coding; <br />
            (c) take any action that imposes an unreasonable or
            disproportionately large load on our infrastructure; or <br />
            (d) copy, reproduce, alter, modify, or publicly display any
            information displayed on the Service (except for Your User Content),
            or create derivative works from our website (other than from Your
            User Content), to the extent that such action(s) would constitute
            copyright infringement or otherwise violate the intellectual
            property rights of Company or any other third party, except with the
            prior written consent of Company or the appropriate third party.
          </p>
          <p>
            <span class="app-tos-topic">Export Restrictions:</span> You
            acknowledge that the Service, or portion thereof may be subject to
            the export control laws of the United States. You will not export,
            re-export, divert, transfer or disclose any portion of the Service
            or any related technical information or materials, directly or
            indirectly, in violation of any applicable export law or regulation.
          </p>
          <p>
            <span class="app-tos-topic">International Use:</span> Recognizing
            the global nature of the Internet, You agree to comply with all
            local rules regarding online conduct and acceptable User Content.
            Specifically, You agree to comply with all applicable laws regarding
            the transmission of technical data exported from the United States
            or the country in which You reside.
          </p>
          <p>
            <span class="app-tos-topic">Modifications:</span> The Company
            reserves the right at any time and from time to time to modify or
            discontinue, temporarily or permanently, the Services (or any part
            thereof) with or without notice, at any time. You agree that the
            Company shall not be liable to You or to any third party for any
            such modification, suspension, termination or discontinuance of the
            Services.
          </p>
          <p>
            <span class="app-tos-topic">No Agency:</span> No agency,
            partnership, joint venture, employee-employer or
            franchisor-franchisee relationship exists or is created between You
            and the Company Software is intended or created by use of these
            Terms of Service.
          </p>
          <p>
            <span class="app-tos-topic">Waiver and Severability:</span> Failure
            by either party to exercise any of its rights under, or to enforce
            any provision of, this Agreement will not be deemed a waiver or
            forfeiture of such rights or ability to enforce such provision. If
            any provision of this Agreement is held by a court of competent
            jurisdiction to be illegal, invalid or unenforceable, that provision
            will be amended to achieve as nearly as possible the same economic
            effect of the original provision and the remainder of this Agreement
            will remain in full force and effect.
          </p>

          <p class="app-tos-topic">Limit of Liability:</p>

          <p>
            IN NO EVENT WILL COMPANY BE LIABLE TO CLIENT FOR CLIENT’S INDIRECT,
            CONSEQUENTIAL, INCIDENTAL, PUNITIVE, EXEMPLARY OR SPECIAL DAMAGES,
            HOWEVER CAUSED, ON ANY THEORY OF LIABILITY, AND WHETHER OR NOT
            CLIENT HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES,
            including, but not limited to, lost profits; lost, reimbursed OR
            RESCINDED revenue; LOSS OR CORRUPTION OF Data; INTERRUPTION, DELAY
            OR INABILITY TO USE THE SERVICES OR WEBSITES; or other penalties or
            fines not described in this SECTION. Exclusioncheck.com and/or
            ProviderTrust’s maximum aggregate liability ARISING UNDER THIS
            AGREEMENT under any theory of liability, including, but not limited
            to, contract, tort (including but not limited to negligence, fraud,
            and willful misconduct), or otherwise, shall NOT EXCEED [$500] per
            individual.
          </p>
          <p>
            <span class="app-tos-topic">Statute of Limitations:</span> You agree
            that regardless of any statute or law to the contrary, any claim or
            cause of action arising of or related to use of Company services or
            the Terms of Service must be filed within one (1) year after such
            claim or cause of action arose or be forever barred.
          </p>
          <p>
            <span class="app-tos-topic">Notices:</span> Any notice under the
            terms of this Agreement or required by law shall be sent to the
            appropriate address set forth below. Either Party may change its
            address for notice by written notice to the other Party.
          </p>
          <p>
            To: Exclusioncheck.com &#8453; ProviderTrust, Inc. <br />
            2300 Charlotte Ave <br />
            Suite 104 Nashville, TN 37203 <br />
            Attn: Exclusioncheck.com Administrator
          </p>
          <p>
            <span class="app-tos-topic">Independent Contractors.</span> The
            relationship between the Parties is that of independent contractors.
            Nothing contained in this Agreement shall be construed as creating
            any agency, partnership, joint venture or other form of joint
            enterprise, employment or fiduciary relationship between the
            Parties, and neither Party shall have authority to contract for or
            bind the other Party in any manner whatsoever.
          </p>
          <p>
            <span class="app-tos-topic">No Third Party Beneficiary:</span>
            Except as expressly stated herein, this Agreement is for the sole
            benefit of the Parties hereto and their respective permitted
            successors and permitted assigns, and nothing herein, express or
            implied, is intended to or shall confer on any other person or
            entity any legal or equitable right, benefit or remedy of any nature
            whatsoever under or by reason of this Agreement.
          </p>
          <p>
            <span class="app-tos-topic">Force Majeure Event.</span> Neither
            Exclusioncheck.com nor ProviderTrust shall not be liable to Client,
            nor be deemed to have defaulted under or breached this Agreement,
            for any failure or delay in fulfilling or performing any term of
            this Agreement, when and to the extent such failure or delay is
            caused by natural disasters, acts of government, power failure,
            fire, flood, acts of God, labor disputes, riots, acts of war,
            national or regional emergency, epidemics, inability to obtain
            materials, failure of internet system providers, and other
            conditions beyond the reasonable control of ProviderTrust (each of
            the foregoing, a <b>"Force Majeure Event"</b>).
          </p>
          <p>
            <span class="app-tos-topic">Assignment:</span> Neither Party may
            assign any of its obligations, rights or remedies hereunder, in
            whole or in part, without the express written approval of the other
            Party; provided, however, that each Party shall have the right, upon
            written notice to the other Party, to assign this Agreement to any
            parent, subsidiary, or other entity under common control or
            ownership with the assigning Party, or to such other entity which
            may result from the merger with, consolidation of, or sale of
            substantially all of the assigning Party’s assets, stock, or
            membership interest.
          </p>
          <p>
            <span class="app-tos-topic">Governing Law and Jurisdiction:</span>
            This Agreement shall be governed in accordance with the laws of the
            State of Tennessee, without regard to its conflict of laws rules.
            Any action to enforce this Agreement may only be brought in a
            federal court in the Middle District of Tennessee, or state court in
            Davidson County, Tennessee.
          </p>
          <p>
            <span class="app-tos-topic">Waiver:</span> The waiver of a breach of
            this Agreement or the failure of a Party to exercise any right or
            remedy under this Agreement shall in no event constitute a waiver as
            to such right or remedy in the future nor as to any other breach,
            right, or remedy, whether similar or dissimilar in nature, or
            prevent the exercise of any right under this Agreement.
          </p>
          <p>
            <span class="app-tos-topic">Construction.</span> The Parties agree
            that the terms of this Agreement result from negotiations between
            them. This Agreement will not be construed in favor of or against
            either Party by reason of authorship.
          </p>
          <p>
            <span class="app-tos-topic">Severability:</span> If any term or
            provision of this Agreement is determined by a court of competent
            jurisdiction to be invalid, illegal or unenforceable, such
            invalidity, illegality or unenforceability shall not affect any
            other term or provision of this Agreement.
          </p>
          <p>
            <span class="app-tos-topic">Entire Agreement:</span> This Agreement
            represents the entire Agreement and supersedes any and all previous
            agreements and understandings between the Parties relating to the
            subject matter hereof.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" flat @click.stop="termsDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "RegistrationTos",

  data() {
    return {
      termsDialog: false
    }
  }
}
</script>

<style lang="scss">
.app-terms-summary {
  font-style: italic;
  margin-left: 1rem;
  max-width: 35rem;
}

.app-tos-topic {
  font-size: 1.2rem;
  text-decoration: underline;
}

.app-tos-topic-bold {
  text-decoration: underline;
  font-weight: bold;
}

.app-tos-sub-topic {
  text-decoration: underline;
}

.app-tos-billing-sub-topic {
  text-decoration: underline;
  font-size: 0.8rem;
  display: block;
}

.app-tos-container {
  font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Registration-Tos.vue